/**
 * 移动端友好反调试工具 - 只检测F12，移动端几乎不检测
 */

// 检测是否为移动端
function isMobile() {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ||
         window.innerWidth <= 768 ||
         'ontouchstart' in window;
}

// 检测F12按键（仅桌面端）
function detectF12(event: KeyboardEvent) {
  // 移动端不检测键盘事件
  if (isMobile()) {
    return;
  }
  
  // F12键
  if (event.keyCode === 123) {
    crashPage();
    return false;
  }
  
  // Ctrl+Shift+I (开发者工具)
  if (event.ctrlKey && event.shiftKey && event.keyCode === 73) {
    crashPage();
    return false;
  }
  
  // Ctrl+Shift+J (控制台)
  if (event.ctrlKey && event.shiftKey && event.keyCode === 74) {
    crashPage();
    return false;
  }
  
  // Ctrl+U (查看源代码)
  if (event.ctrlKey && event.keyCode === 85) {
    crashPage();
    return false;
  }
  
  // Ctrl+Shift+C (检查元素)
  if (event.ctrlKey && event.shiftKey && event.keyCode === 67) {
    crashPage();
    return false;
  }
}

// 让页面崩溃
function crashPage() {
  // 温和的崩溃方式：重定向到空白页
  window.location.href = 'about:blank';
}

// 初始化移动端友好反调试
export function initMobileFriendlyAntiDebug() {
  // 检测F12和快捷键（仅桌面端）
  document.addEventListener('keydown', detectF12);
  
  // 移动端几乎不检测，只检测F12
  if (!isMobile()) {
    // 桌面端才检测开发者工具
    setInterval(() => {
      // 简单的窗口大小检测
      const threshold = 160;
      const widthThreshold = window.outerWidth - window.innerWidth > threshold;
      const heightThreshold = window.outerHeight - window.innerHeight > threshold;
      
      if (widthThreshold || heightThreshold) {
        crashPage();
      }
    }, 3000); // 降低检测频率
  }
  
  const deviceType = isMobile() ? '移动端' : '桌面端';
  console.log(`🛡️ 移动端友好反调试保护已启用 (${deviceType}) - 移动端几乎不检测`);
}

// 导出崩溃函数
export { crashPage };
